import React from 'react'

import { Tab, Tabs } from '@mui/material'
import Box from '@mui/material/Box'

import { styles } from './FilterRow.styles'

export const TEST_ID = 'published-ideas-filter'

export type Props = {
	buttonOnClick: () => void
	disabled: boolean
}

export default function FilterRow() {
	const [selectedTab, setSelectedTab] = React.useState(0)

	const handleTabChange = (
		_event: React.SyntheticEvent,
		newValue: number
	) => {
		setSelectedTab(newValue)
	}

	return (
		<Box sx={styles.tabsContainer}>
			<Tabs
				value={selectedTab}
				onChange={handleTabChange}
				sx={styles.tabs}
				data-testid={`${TEST_ID}-tabs`}
			>
				<Tab
					label="MY GAMES"
					sx={styles.tab}
					data-testid={`${TEST_ID}-my-games-tab`}
				/>
				<Tab
					label="GAMES I'M INVITED TO"
					sx={styles.tab}
					data-testid={`${TEST_ID}-invited-games-tab`}
				/>
				<Tab
					label="ARCHIVED GAMES"
					sx={styles.tab}
					data-testid={`${TEST_ID}-archived-games-tab`}
				/>
			</Tabs>
		</Box>
	)
}
